
























































import Vue from "vue";
import { mapActions } from "vuex";
import { AuthPlugin } from "@canvas/authplugin";
import { User } from "../types";
export default Vue.extend({
  data() {
    return {
      loginBtn: {
        isDisabled: false
      },
      googleSigninBtn: {
        isDisabled: false
      }
    };
  },
  props: {
    errorMessage: {
      type: String || null,
      default: null
    }
  },
  methods: {
    handleSignIn() {
      const auth = AuthPlugin.getAuth();
      return auth
        .authorize()
        .then((user: User | null) => {
          if (user) {
            this.$store.commit("appModule/setLoggedInUser", user);
            // this.$router.push({ path: "/workspace" });
          } else {
            // alert(`Did not get any user information for logged in user!`);
          }
        })
        .catch((err: Error) => {
          alert(`Could not login!
        ${err.name}
        ${err.message}
        `);
        });
    },

    handleWithButtonAction(
      asyncFunc: (...args: any) => Promise<any>,
      button: { isDisabled: boolean }
    ) {
      button.isDisabled = true;
      this.$store.dispatch("appModule/trackSegementEvents", {
        eventName: "LOGIN_CLICKED"
      });
      return asyncFunc
        .apply(arguments)
        .then(() => {
          this.$store.dispatch("appModule/trackSegementEvents", {
            eventName: "LOGIN_SUCCESS"
          });
          // removing enabling button as redirect will auto happen
          // button.isDisabled = false;
        })
        .catch((err: any) => {
          this.$store.dispatch("appModule/trackSegementEvents", {
            eventName: "LOGIN_FAILED"
          });
          button.isDisabled = false;
          alert("Error in login");
        });
    }
  }
});
